import styled from "styled-components";
import { riskLevel } from "../../constants/riskLevel";
import { DEVICES } from "../../constants/devices";

export default function CalculatedResult({ isSatellite, isCalculated, result, calculatedResult }) {
  return (
    <ResultContainer>
      {isSatellite && isCalculated && (!!calculatedResult || result) && (
        <>
          <div className="item">The overall risk indicator of your asset based on the analysed drivers is evaluated as:</div>
          <div className="item item--zoneScore">
            {riskLevel[calculatedResult || result?.zoneScore]} ({calculatedResult || result?.zoneScore}/5)
          </div>
        </>
      )}
      {isSatellite && isCalculated && result && (calculatedResult || result?.zoneScore >= 2) && (
        <div className="item">We identify a risk reduction potential towards a low risk exposure.</div>
      )}
      {isSatellite && isCalculated && result && <div className="item">We recommend a minimal water volume of {Math.round(result?.waterVolume)} liters.</div>}
      <div className="item item--zone">
        <div style={{ minWidth: "73%" }}>Perimeter length analysed:</div> <div>{Math.round(result.distance)} meters</div>
      </div>
      {/* <div className="item"><div>Water volume required:</div> <div>{Math.round(result.waterVolume)} liters</div></div> */}
      {!isSatellite && (
        <>
          <div className="item">
            <div>Running time required:</div> <div>{result.runningTime} minutes</div>
          </div>
          <div className="item">
            <div>Success probability:</div> <div>{result.successProbability * 100 + "%"}</div>
          </div>
        </>
      )}
      {Object.keys(result.groupedLineDistance).length > 0 && (
        <div className="item-group">
          {Object.entries(result.groupedLineDistance).map(([k, v]) => (
            <div className="item item--zone" key={k}>
              <div>{k.charAt(0).toUpperCase() + k.slice(1)} distance:</div>{" "}
              <div>
                {Math.round(v)} meters / {Math.round(result.percentage[k])}%
              </div>
            </div>
          ))}
        </div>
      )}
    </ResultContainer>
  );
}

const ResultContainer = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 14px;
  width: 263px;
  z-index: 2;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  backdrop-filter: blur(8px);
  background: rgb(238 238 238 / 70%);
  border: 1px solid #f6f8fb;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 4px rgb(50 50 71 / 8%), 0 4px 8px rgb(50 50 71 / 6%);

  .item-group {
    margin-top: 10px;
  }

  .item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    & > div:first-child {
      margin-right: 5px;
    }

    &--zone {
      margin-bottom: 5px;
    }

    &--zoneScore {
      align-self: center;
      font-size: 20px;
      font-weight: 700;
    }
  }

  @media ${DEVICES.mobileL} {
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
`;
